import axios from 'axios'
import {
  BalanceType
} from 'src/core/models'

export async function getBalanceAPI(): Promise<BalanceType[]> {
  const { data } = await axios.get(`/api/v1/balances/`)
  return data
}

export async function salesData(filter = 365) {
  const response = await axios.get(`/api/v1/orders/get_sales_data/?total=${filter}`)
  return response.data
}
export async function ordersData(filter = 365) {
  const response = await axios.get(`/api/v1/orders/get_orders_data/?total=${filter}`)
  return response.data
}

export async function createDepositAPI(payload) {
  const response = await  axios.post('/api/v1/deposits/', payload)
  return response.data
}

export async function getPaymentUrl(id) {
  const marketUrl = process.env.MARKET_PLACE_URL
  const response = await axios.get(`/api/v1/deposits/${id}/get_paypal_payment_url/`, {
    params: {
      url_ok: `${marketUrl}/accounts/payments/paypal?depositId=${id}`,
      url_ko: `${marketUrl}/accounts/payments/error`
    }
  })
  return response.data
}

export async function getCreditCardInfo(payload) {
  const response = await axios.post(`/api/v1/credit_card_info/`, payload)
  return response.data
}

export async function createWithdrawWithPayPal(payload: FormData) {
  const config = { headers: { 'Content-Type': 'multipart/form-data' } }
  const { data } = await axios.post('/api/v1/withdrawals/', payload, config)
  return data
}

export async function createDeposit (payload) {
  const response = await axios.post(`/api/v1/payments/create_credit_card_deposit/`, payload)
  return response.data
}
